<template>
  <div id="select-unit2">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <ul>
      <!-- 製品シリーズ -->
      <li class="side_tab_item">
        <div class="side_tab_header">
          <select v-if="seriesList && seriesList.length" v-model="seriesNo" @change="changeCond">
            <option v-for="(series, index) in seriesList" :key= index :value="series.seriesNo" >{{series.seriesName}}</option>
          </select>
          <input class="input" type="text" v-model="umCode" @focus="isFocusUmcode=true" @blur="isFocusUmcode=false"
            @keyup.enter="searchByUmCode" placeholder="UMコード/名称">
          <button class="main_btn" @click="searchByUmCode">検索</button>
        </div>
      </li>

      <li class="side_tab_item">
        <div id="sub_tab_area">
          <ul>
            <!-- オブジェクトタイプ -->
            <li class="tab_list">
              <span id="arrow_left" @click="scrollTabById('dispTab1', true)" v-if="menuDisp(0)">
                <img :src="getDarosResource('component/unit/ic_arrow_left2.svg')" width="10px" height="10px">
              </span>
              <ul class="tab_row show" id="dispTab1">
                <li v-for="(objectType, index) in objectTypeList"
                  :key="'unit-grp-' + index"
                  :class="(dispFileDataListCond.objectType === objectType.code) ? 'active' : ''"
                  @click="changeObjectType(objectType.code)"
                >
                  {{objectType.label}}
                </li>
              </ul>
              <span id="arrow_right" @click="scrollTabById('dispTab1', false)" v-if="menuDisp(0)">
                <img :src="getDarosResource('component/unit/ic_arrow_right2.svg')" width="10px" height="10px">
              </span>
            </li>
            <!-- 工場タイプ -->
            <li v-if="isFactoryDisp" class="tab_list">
              <span id="arrow_left" @click="scrollTabById('dispTab2', true)" v-if="menuDisp(1)">
                <img :src="getDarosResource('component/unit/ic_arrow_left2.svg')" width="10px" height="10px">
              </span>
              <ul class="tab_row show" id="dispTab2">
                <li v-for="(groupType, index) in factoryTypeList"
                  :key="'fact-grp-' + index"
                  :class="(dispFileDataListCond.factoryType === groupType.code) ? 'active' : ''"
                  @click="changeFactoryType(groupType.code)"
                >
                  {{groupType.label}}
                </li>
              </ul>
              <span id="arrow_right" @click="scrollTabById('dispTab2', false)" v-if="menuDisp(1)">
                <img :src="getDarosResource('component/unit/ic_arrow_right2.svg')" width="10px" height="10px">
              </span>
            </li>
            <!-- ユニットグループタイプ -->
            <li v-if="isObjTypeUnit" class="tab_list">
              <span id="arrow_left" @click="scrollTabById('dispTab3', true)" v-if="menuDisp(2)">
                <img :src="getDarosResource('component/unit/ic_arrow_left2.svg')" width="10px" height="10px">
              </span>
              <ul class="tab_row show" id="dispTab3">
                <li v-for="(unitGroupType, index) in unitGroupTypeList"
                  :key="'unit-grp-' + index"
                  :class="(dispFileDataListCond.unitGroupType === unitGroupType.code) ? 'active' : ''"
                  @click="changeUnitGroupType(unitGroupType.code)"
                >
                  {{unitGroupType.label}}
                </li>
              </ul>
              <span id="arrow_right" @click="scrollTabById('dispTab3', false)" v-if="menuDisp(2)">
                <img :src="getDarosResource('component/unit/ic_arrow_right2.svg')" width="10px" height="10px">
              </span>
            </li>
            <!-- ユニットオブジェクトグループ・カテゴリー -->
            <li class="tab_list">
              <span id="arrow_left" @click="scrollTabById('group_tab', true)" v-if="menuDisp(3)">
                <img :src="getDarosResource('component/unit/ic_arrow_left2.svg')" width="10px" height="10px">
              </span>
              <ul class="tab_row show" id="group_tab">
                <!-- ユニットオブジェクトグループ -->
                <li
                  v-for="(objGroup, index) in objGroupList"
                  v-if="isUnit && objGroup.unitGroupType === dispFileDataListCond.unitGroupType"
                  :key="'obj-grp-' + index"
                  :class="{active: dispFileDataListCond.objGroupType === objGroup.objGroupType,
                    tab_disable: dispTrialUserTools && objGroup.objGroupType === 'TYPE_OBJGRP_UT_PANEL'}"
                  :data-obj-grp="objGroup.objGroupType"
                  @click="changeObjGrpType"
                >
                  {{ objGroup.objGroupName }}
                </li>
                <!-- アクセサリー大カテゴリー -->
                <li
                  v-if="isAccessoryCategory"
                  v-for="(accessoryCategory, index) in accessoryCategoryList"
                  :key="'accessory-cat-' + index"
                  :class="(dispFileDataListCond.accessoryCategoryId === accessoryCategory.accessoryCategoryId) ? 'active' : ''"
                  @click="changeAccessoryCategory(accessoryCategory.accessoryCategoryId)"
                >
                  {{ accessoryCategory.accessoryCategoryName }}
                </li>
                <!-- カテゴリー -->
                <li
                  v-for="(category, index) in setCategoryTab"
                  :key="'cat-' + index"
                  :class="{active: dispFileDataListCond.category === category.categoryNo}"
                  :data-category="category.categoryNo"
                  @click="changeCategory"
                >
                  {{ category.categoryName }}
                </li>
                <!-- サービスタイプ -->
                <li
                  v-if="dispFileDataListCond.openFileFlg"
                  v-for="(serviceType, index) in serviceTypeList"
                  :key="'service-grp-' + index"
                  :class="(dispFileDataListCond.serviceType === serviceType.code) ? 'active' : ''"
                  @click="changeServiceType(serviceType.code)"
                >
                  {{serviceType.label}}
                <li
                  v-if="sketchMenu && dispFileDataListCond.sketchFlg"
                  v-for="(serviceType, index) in serviceTypeList"
                  :key="'service-grp-' + index"
                  :class="(dispFileDataListCond.serviceType === serviceType.code) ? 'active' : ''"
                  @click="changeServiceType(serviceType.code)"
                >
                  {{serviceType.label}}
                </li>
              </ul>
              <span id="arrow_right" @click="scrollTabById('group_tab', false)" v-if="menuDisp(3)">
                <img :src="getDarosResource('component/unit/ic_arrow_right2.svg')" width="10px" height="10px">
              </span>
            </li>
            <!-- 特注ユニット -->
            <li v-if="distCustomTab && isGroupTypeSkl">
              <ul class="tab_row show">
                <li v-for="(customType, index) in customTypeList"
                  :key="'custom-grp-' + index"
                  :class="(dispFileDataListCond.customType === customType.code) ? 'active' : ''"
                  @click="changeCustomType(customType.code)"
                >
                  {{customType.label + groupName}}
                </li>
              </ul>
            </li>
            <!-- アクセサリー小カテゴリー -->
            <li class="scroll_list, tab_list" v-if="isAccessorySubCategory">
              <span id="arrow_left" @click="scrollTabById('accesTab', true)" v-if="menuDisp(4)">
                <img :src="getDarosResource('component/unit/ic_arrow_left2.svg')" width="10px" height="10px">
              </span>
              <ul class="tab_row show" id="accesTab" >
                <li v-for="(accessorySubCategory, index) in sortedAccessoryCategory"
                  :key="'accessory-sub-cat-' + index"
                  :class="(dispFileDataListCond.accessorySubCategoryId === accessorySubCategory.accessoryCategoryId) ? 'active' : ''"
                  @click="changeAccessorySubCategory(accessorySubCategory.accessoryCategoryId)"
                >
                  {{ accessorySubCategory.accessoryCategoryName }}
                </li>
              </ul>
              <span id="arrow_right" @click="scrollTabById('accesTab', false)" v-if="menuDisp(4)">
                <img :src="getDarosResource('component/unit/ic_arrow_right2.svg')" width="10px" height="10px">
              </span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <!-- 一覧 -->
    <div id="sub_tab_contents_area" :style="{height: subTabContentsAreaH}">
      <div id="sub_tab_contents" @scroll="scroll">
        <!-- ユニット・コンバイン・プランデータ一覧 -->
        <div
          class="side_unitlist container"
          v-if="dispFileDataList && dispFileDataList.length > 0"
          v-for="fileData in dispFileDataList"
          v-bind:class="{select_item: selectSpaceJoincd==fileData.spaceJoincd, grabbable: isGrabbable(fileData)}"
          :key="fileData.spaceJoincd"
          :data-space-joincd="fileData.spaceJoincd"
          :data-top-space-id="fileData.topSpaceModel.id"
          :data-object-type="fileData.topSpaceModel.spaceObjectType"
          :data-planning-type="fileData.topSpaceModel.planningType"
          :data-category="fileData.categoryNo"
          @mousedown="$emit('setDraggedFileData', fileData)"
          @click="$emit('onClickList', fileData.spaceJoincd); selectedSpace(fileData.spaceJoincd); $emit('getTotalPrice', fileData.spaceJoincd)"
         >

          <div class="side_unitlist_left">
            <img :src="getFileImg(fileData)" @error="noImage" alt="unitData"/>
          </div>
          <div class="side_unitlist_right">
            <h4 class="unit_name">
              <div class="side_plan_name" v-if="!isSketch" style="width: 309.7px;">{{ fileData.fileName }}</div>
              <div class="side_plan_name" v-if="isSketch" style="width: 309.7px;">{{ fileData.planEcModel.ecSnapUserLastName + fileData.planEcModel.ecSnapUserFirstName + ' 様' + '(' + fileData.planEcModel.ecSnapCorpName + ')' }}</div>
              <span class="side_plan_cd">{{ fileData.fileCode }}</span>
            </h4>
            <p class="unit_specification">{{ fileData.objectDataModelList[0].objSpecification }}</p>
            <p class="unit_caption">{{ fileData.fileCaption }}</p>
            <div class="edit_button" v-if="isUnit && isSrvContentsData">
              <a @click="$emit('showContentsDataModal', fileData)" @mousedown.stop>コンテンツ登録</a>
            </div>
            <!-- isSelectedがtrueの場合、Output.vueからの呼び出しと判断しDOM生成しない -->
            <div class="edit_button" v-if="isEditableFile && !isSelected">
              <a v-if="isSketch" @click="$emit('onClickSketchView', fileData)" @mousedown.stop>スケッチ情報</a>
              <a v-if="dispMmstyleShop && isSketch && targetSpaceJoincd !== fileData.spaceJoincd" @click="$emit('onClickSketchAddCart', fileData)" @mousedown.stop>カート追加</a>
              <a v-if="dispMmstyleShop && !isOpenFile && !isSketch && isSetPlan" @click="$emit('onClickMmstyleRequest', fileData)" @mousedown.stop>公開申請</a>
              <a v-if="dispMmstyleShop && !isSketch && (fileData.openStatus === 0 || fileData.openStatus === 1)" @click="$emit('onClickMmstyleCancel', fileData)" @mousedown.stop>公開取消</a>
              <a v-if="canSpaceEdit && !isUnit && !isSetPlan && targetSpaceJoincd !== fileData.spaceJoincd" @click="$emit('onClickEdit', fileData.spaceJoincd)" @mousedown.stop>編集</a>
              <a v-if="!isOpenFile && !isSketch" @click="$emit('onClickDeleteFile', fileData.spaceJoincd)" @mousedown.stop>削除</a>
              <a v-if="isSrvContentsData && !isSketch" @click="$emit('showContentsDataModal', fileData)" @mousedown.stop>コンテンツ登録</a>
            </div>
            <div class="edit_icon">
              <span v-if="targetSpaceJoincd === fileData.spaceJoincd">編集中</span>
            </div>
            <div class="setplan_icon">
              <span v-if="fileData.openStatus === 0">公開中</span>
              <span v-if="fileData.openStatus === 1">申請中</span>
              <span v-if="fileData.topSpaceModel.spaceObjectType === 'TYPE_OBJ_SETPLAN'">ルール付き</span>
              <span v-if="fileData.topSpaceModel.spaceObjectType === 'TYPE_OBJ_SETPLAN_FIX'">固定</span>
            </div>
          </div>
        </div>
        <div class="data_not_found" v-if="showTab && dispFileDataList.length === 0 && !onLoad">データがありません。</div>
        <div class="data_not_found" v-if="showTab && dispFileDataList.length === 0 && onLoad">読み込み中...</div>
      </div>
    </div>
    <img class="left_contact" v-if="dispTrialUserTools" width="100%" :src="leftContact" alt="leftContact" @click="showContact()">
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL} from '../../constants/App'
import {OBJECT_TYPE, OBJECT_GROUP_TYPE, UNIT_GROUP_TYPE, LICENSE_TYPE, SERVICE_TYPE, FACTORY_TYPE} from '../../constants/Type'
import * as Api from '../../utils/Api'
import LoadingModal from './LoadingModal'
import * as AppUtil from '../../utils/App'
import SupportModal from './SupportModal'

export default {
  name: 'SelectUnit2',
  components: {
    'dd-loading-modal': LoadingModal,
    'dd-support-modal': SupportModal
  },
  props: {
    canSpaceEdit: Boolean,
    targetSpaceJoincd: String,
    isTabHide: {
      type: Boolean,
      default: false
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    sideWidth: null,
    isLoading: Boolean
  },
  data () {
    return {
      /** シリーズデータリスト */
      seriesList: [],
      /** カテゴリデータリスト */
      categoryList: [],
      /** ファイルデータリスト */
      fileDataList: [],
      /** 表示するファイルデータリスト */
      dispFileDataList: [],
      /** ファイルデータリストフィルタリング条件 */
      dispFileDataListCond: {
        series: null,
        category: 1,
        // オブジェクトタイプ
        objectType: OBJECT_TYPE.UNIT.code,
        // オブジェクトグループタイプ
        objGroupType: OBJECT_GROUP_TYPE.CABINET.code,
        // ユニットグループタイプ
        unitGroupType: UNIT_GROUP_TYPE.SKELTON.code,
        // 公開プラン
        openFileFlg: false,
        // スケッチオーダープラン
        sketchFlg: false,
        // サービスタイプ
        serviceType: SERVICE_TYPE.MMSTYLE.code,
        // 特注タイプ
        customType: 0,
        // 工場タイプ
        factoryType: FACTORY_TYPE.KUMIAI.code,
        // ユニットコード
        umCode: null,
        // アクセサリー大カテゴリータイプ
        accessoryCategoryId: null,
        // アクセサリー小カテゴリータイプ
        accessorySubCategoryId: null
      },
      objectTypeList: [
        OBJECT_TYPE.UNIT,
        OBJECT_TYPE.COMBINE,
        OBJECT_TYPE.SETPLAN,
        OBJECT_TYPE.PLAN
      ],
      factoryTypeList: [
        FACTORY_TYPE.KUMIAI,
        FACTORY_TYPE.KAMEI
        // FACTORY_TYPE.OLIS
      ],
      unitGroupTypeList: [
        UNIT_GROUP_TYPE.SKELTON,
        UNIT_GROUP_TYPE.INFILL,
        UNIT_GROUP_TYPE.SURFACE,
        UNIT_GROUP_TYPE.ACCESSORY
      ],
      customTypeList: [
        {label: '', code: 0},
        {label: '特注', code: 1}
      ],
      serviceTypeList: [SERVICE_TYPE.MMSTYLE],
      dispCategoryList: [],
      objGroupList: [],
      accessoryCategoryList: [],
      accessorySubCategoryList: [],
      showTab: false,
      seriesNo: 1,
      /** 選択されたシリーズ */
      selectSeries: {},
      /** UMコード検索ワード */
      umCode: null,
      /** UMコード検索へのフォーカス判定 */
      isFocusUmcode: false,
      /** 選択項目 */
      selectSpaceJoincd: -1,
      imgLeft: this.getDarosResource('component/unit/ic_arrow_left2.svg'),
      imgRight: this.getDarosResource('component/unit/ic_arrow_right2.svg'),
      /** 画像 */
      planImg: this.getDarosResource('pages/planning/ic_big_plan_off.png'),
      unitImg: this.getDarosResource('pages/planning/ic_big_unit_on.png'),
      combineImg: this.getDarosResource('pages/planning/ic_big_cmb_off.png'),
      ruledSetPlanImg: this.getDarosResource('pages/planning/ic_big_ruledsetplan_.png'),
      setPlanImg: this.getDarosResource('pages/planning/ic_big_setplan_off.png'),
      leftContact: this.getDarosResource('pages/planning/left_contact.png'),
      offset: 0,
      /** 全データ取得済み判定 */
      isMaxData: false,
      /** 読み込み中判定 */
      onLoad: false,
      commonTabNo: 1
    }
  },
  watch: {
    'dispFileDataListCond': {
      handler: function () {
        this.changeCond()
      },
      deep: true
    },
    isFocusUmcode: function () {
      if (this.isFocusUmcode) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
    /** ファイルデータ編集ボタン表示制御 */
    isEditableFile: function () {
      return this.dispFileDataListCond.objectType !== OBJECT_TYPE.UNIT.code
    },
    /** ユニットデータ表示制御 */
    isUnit: function () {
      return this.dispFileDataListCond.objectType === OBJECT_TYPE.UNIT.code
    },
    /** ユニットデータ表示制御 */
    isCombine: function () {
      return this.dispFileDataListCond.objectType === OBJECT_TYPE.COMBINE.code
    },
    /** セットプランデータ表示制御 */
    isSetPlan: function () {
      return this.dispFileDataListCond.objectType === OBJECT_TYPE.SETPLAN.code || this.dispFileDataListCond.objectType === OBJECT_TYPE.SETPLAN_FIX.code
    },
    /** プランデータ表示制御 */
    isPlan: function () {
      return this.dispFileDataListCond.objectType === OBJECT_TYPE.PLAN.code
    },
    /** 公開中プランデータ表示制御 */
    isOpenFile: function () {
      return this.dispFileDataListCond.openFileFlg
    },
    /** スケッチオーダー表示制御 */
    isSketch: function () {
      return this.dispFileDataListCond.sketchFlg
    },
    /** 条件のオブジェクトタイプがユニット */
    isObjTypeUnit: function () {
      return this.dispFileDataListCond.objectType === 'TYPE_OBJ_UNIT'
    },
    /** 条件のグループタイプがスケルトン */
    isGroupTypeSkl: function () {
      let user = AppUtil.getUserInfo()
      if (user.corpId === 170) return false
      return this.isObjTypeUnit && this.dispFileDataListCond.objGroupType === OBJECT_GROUP_TYPE.CABINET.code
    },
    /** コンテンツデータサービスの登録の判定 */
    isSrvContentsData: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.contentsData
    },
    /** アクセサリー大カテゴリー表示制御 */
    isAccessoryCategory: function () {
      return this.dispFileDataListCond.unitGroupType === UNIT_GROUP_TYPE.ACCESSORY.code
    },
    /** アクセサリー小カテゴリー表示制御 */
    isAccessorySubCategory: function () {
      return this.dispFileDataListCond.accessoryCategoryId !== null && this.dispFileDataListCond.unitGroupType === UNIT_GROUP_TYPE.ACCESSORY.code
    },
    /** オーダー家具 */
    isOrder: function () {
      let user = AppUtil.getUserInfo()
      return user.corpId === 170
    },
    isFactoryDisp: function () {
      return this.isOrder && (this.dispFileDataListCond.objectType === OBJECT_TYPE.UNIT.code)
    },
    /** お試しユーザー用ツール表示 */
    dispTrialUserTools: function () {
      let user = AppUtil.getUserInfo()
      return user && LICENSE_TYPE.TRIAL === user.licenseType
    },
    /** ミリスタイル公開ボタン表示 */
    dispMmstyleShop: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.mmstyleShop
    },
    /** スケッチオーダー表示 */
    sketchMenu: function () {
      return false
      // let user = AppUtil.getUserInfo()
      // return user && user.menuServiceCode.sketchMenu
    },
    mm_openFlag: function () {
      let user = AppUtil.getUserInfo()
      return user.corpId !== 170
    },
    /** 特注タブ表示 */
    distCustomTab: function () {
      let user = AppUtil.getUserInfo()
      return user && user.menuServiceCode.unitTabCustom
    },
    /** ファイルデータ一覧の高さ */
    subTabContentsAreaH: function () {
      if (this.dispTrialUserTools) {
        return this.isObjTypeUnit ? 'calc(100% - 300px)' : 'calc(100% - 263px)'
      }
      if (this.isAccessorySubCategory) {
        return 'calc(100% - 202px)'
      }
      if (this.isObjTypeUnit) {
        return 'calc(100% - 160px)'
      }
      return 'calc(100% - 84px)'
      // return this.dispTrialUserTools
      //  ? this.isObjTypeUnit ? 'calc(100% - 300px)' : 'calc(100% - 263px)'
      //  : this.isObjTypeUnit ? 'calc(100% - 160px)' : 'calc(100% - 124px)'
    },
    setCategoryTab: function () {
      let dispList = {}
      if (!this.isUnit && this.dispCategoryList && this.dispCategoryList.length > 0 && !this.isOpenFile) {
        // ユニット・公開中タブ以外
        if (this.isCombine) {
          // コンバインタブ
          dispList = this.dispCategoryList.filter((category) => category.topObjTypeName === OBJECT_TYPE.COMBINE.code || category.categoryNo === this.commonTabNo)
        } else if (this.isSetPlan) {
          // セットプランタブ
          dispList = this.dispCategoryList.filter((category) => category.topObjTypeName === OBJECT_TYPE.SETPLAN.code || category.categoryNo === this.commonTabNo)
        } else if (this.isPlan) {
          // プランタブ
          dispList = this.dispCategoryList.filter((category) => category.topObjTypeName === OBJECT_TYPE.PLAN.code || category.categoryNo === this.commonTabNo)
        }
      } else {
        // ユニット・公開中タブ
        dispList = {}
      }
      return dispList
    },
    groupName: function () {
      if (this.objGroupList.length > 0) {
        return this.objGroupList.find(o => o.objGroupType === this.dispFileDataListCond.objGroupType).objGroupName
      } else {
        return ''
      }
    },
    // アクセサリーの大カテゴリーに合致する小カテゴリーへ詰め替え
    sortedAccessoryCategory: function () {
      return this.accessorySubCategoryList.filter((accessorySubCategory) => accessorySubCategory.accessoryParentId === this.dispFileDataListCond.accessoryCategoryId)
    }
  },
  methods: {
    /** ユニットリスト初期化処理 */
    init: function () {
      this.getSeriesList()
    },
    /** シリーズ一覧取得 */
    getSeriesList: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.PLANNING + '/series'
      ).then(response => {
        this.seriesList = response.data.data.seriesList
        this.dispCategoryList = response.data.data.categoryList
        this.objGroupList = response.data.data.objectGroupList
        this.accessoryCategoryList = response.data.data.accessoryCategoryList
        this.accessorySubCategoryList = response.data.data.accessorySubCategoryList
        this.getFileDataList()
      }).catch(error => {
        Api.handleError(error)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    /** ファイルデータ一覧取得 */
    getFileDataList: function () {
      let payload = {
        seriesNo: this.seriesNo,
        category: this.dispFileDataListCond.category,
        objectType: this.dispFileDataListCond.objectType,
        objGroupType: this.dispFileDataListCond.objGroupType,
        openFileFlg: this.dispFileDataListCond.openFileFlg,
        sketchFlg: this.dispFileDataListCond.sketchFlg,
        serviceType: this.dispFileDataListCond.serviceType,
        customType: this.checkCustomType(this.dispFileDataListCond.customType),
        accessorySubCategoryId: this.dispFileDataListCond.accessorySubCategoryId,
        umCode: this.dispFileDataListCond.umCode,
        factoryType: this.dispFileDataListCond.factoryType,
        offset: this.offset
      }
      this.$parent.isLoadingFileList = true
      if (!this.isMaxData) {
        axios.post(API_URL.PLANNING + '/list', payload)
          .then(response => {
            this.$parent.isLoadingFileList = false
            // 編集中ファイルも取得済みならローディングを消す
            if (!this.isLoading) {
              this.$refs.loadingModalRef.showModal(false)
            }
            let newDataList = response.data.data ? response.data.data : []
            this.isMaxData = newDataList.length === 0
            if (this.offset === 0) {
              this.fileDataList = []
            }
            // 取得したリストを重複を除いて追加
            var joinDataList = [...this.fileDataList, ...newDataList]
              .reduce((obj, data) => {
                obj[data.spaceJoincd] = data
                return obj
              }, {})
            this.fileDataList = Object.values(joinDataList)
            this.dispFileDataList = this.fileDataList
            this.showTab = true
            /** 選択されているシリーズオブジェクト取得 */
            this.selectSeries = this.seriesList.find(s => this.seriesNo === s.seriesNo)
            this.$nextTick(function () {
              this.$emit('setSelectSeries', this.selectSeries)
            })
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            Api.handleError(error)
          })
          .finally(() => {
            this.onLoad = false
            this.$refs.loadingModalRef.showModal(false)
          })
      } else {
        this.$refs.loadingModalRef.showModal(false)
      }
    },
    /** ファイル画像表示 */
    getFileImg: function (fileData) {
      let contentsDataModel = fileData.contentsDataModel
      if (contentsDataModel != null && contentsDataModel.contentsImgSmall) {
        return this.getContentsResource(fileData.corpId + '/' + contentsDataModel.contentsImgSmall)
      }
      if (fileData.iconImageData) {
        return fileData.iconImageData
      }
      let fileName = fileData.iconName ? fileData.iconName.replace(/'/g, "¥'") : 'noimage'
      return this.getDarosResource(fileName + '.svg')
    },
    /** スクロール時 */
    scroll: function (e) {
      const checkScrollHeight = Math.ceil(e.target.scrollTop + e.target.offsetHeight)
      if (!this.onLoad && checkScrollHeight >= e.target.scrollHeight) {
        this.onLoad = true
        this.offset = this.dispFileDataList.length
        this.getFileDataList()
      }
    },
    searchByUmCode: function () {
      this.dispFileDataListCond.umCode = this.umCode
    },
    /** cursor: grab制御 */
    isGrabbable: function (fileData) {
      return OBJECT_TYPE.PLAN.code !== fileData.topSpaceModel.spaceObjectType
    },
    /** ファイルデータ選択 */
    selectedSpace: function (spaceJoincd) {
      if (!this.isSelected) return
      this.selectSpaceJoincd = spaceJoincd
    },
    /** オブジェクトグループ・カテゴリータブの左右のスクロール */
    scrollTabById: function (id, isLeft) {
      const scrollAmount = 100
      let element = document.getElementById(id)
      element.scrollLeft += (isLeft ? -1 : 1) * scrollAmount
    },
    // *****************************************************************
    // タブ切替え
    // *****************************************************************
    /** 条件の変更 */
    changeCond: function () {
      this.onLoad = true
      this.dispFileDataList = []
      this.offset = 0
      this.isMaxData = false
      this.getFileDataList()
      document.getElementById('sub_tab_contents').scrollTop = 0
    },
    /** オブジェクトタイプの変更 */
    changeObjectType: function (objectType) {
      // コンバイン・プラン切り替え時のカテゴリ初期化対応
      if (objectType !== this.dispFileDataListCond.objectType) {
        this.dispFileDataListCond.objectType = objectType
        this.dispFileDataListCond.unitGroupType = UNIT_GROUP_TYPE.SKELTON.code
        this.dispFileDataListCond.objGroupType = this.objGroupList.length > 0 ? this.objGroupList[0].objGroupType : ''
        this.dispFileDataListCond.category = this.dispCategoryList.length > 0 ? this.dispCategoryList[0].categoryNo : ''
        this.dispFileDataListCond.customType = 0
        this.dispFileDataListCond.umCode = ''
      }
      this.dispFileDataListCond.openFileFlg = false
      this.dispFileDataListCond.sketchFlg = false
      this.resetAccessoryCategoryId()
    },
    /** 公開プランへの変更 */
    changeOpenFileFlg: function () {
      this.dispFileDataListCond.openFileFlg = true
      this.dispFileDataListCond.sketchFlg = false
      this.dispFileDataListCond.serviceType = SERVICE_TYPE.MMSTYLE.code
      this.dispFileDataListCond.objectType = ''
      this.dispFileDataListCond.categoryNo = ''
      this.dispFileDataListCond.customType = ''
      this.dispFileDataListCond.umCode = ''
      this.resetAccessoryCategoryId()
    },
    /** スケッチオーダープランへの変更 */
    changeSketchFlg: function () {
      this.dispFileDataListCond.sketchFlg = true
      this.dispFileDataListCond.openFileFlg = false
      this.dispFileDataListCond.serviceType = SERVICE_TYPE.DAROS.code
      this.dispFileDataListCond.objectType = ''
      this.dispFileDataListCond.categoryNo = ''
      this.dispFileDataListCond.customType = ''
      this.dispFileDataListCond.umCode = ''
      this.resetAccessoryCategoryId()
    },
    /** 工場タイプの変更 */
    changeFactoryType: function (factoryType) {
      if (factoryType !== this.dispFileDataListCond.factoryType) {
        // this.resetAccessoryCategoryId()
        this.dispFileDataListCond.factoryType = factoryType
        this.dispFileDataListCond.umCode = ''
      }
    },
    /** ユニットグループタイプの変更 */
    changeUnitGroupType: function (unitGroupType) {
      if (unitGroupType !== this.dispFileDataListCond.unitGroupType) {
        // アクセサリーを選択時に一番左側のタブがアクティブになるよう設定
        if (unitGroupType === UNIT_GROUP_TYPE.ACCESSORY.code) {
          this.dispFileDataListCond.accessoryCategoryId = this.accessoryCategoryList[0].accessoryCategoryId
          this.dispFileDataListCond.accessorySubCategoryId = this.sortedAccessoryCategory[0].accessoryCategoryId
          this.dispFileDataListCond.objGroupType = OBJECT_GROUP_TYPE.ACCESSORY.code
        } else {
          this.dispFileDataListCond.objGroupType = this.objGroupList.find(objGroup => {
            return objGroup.unitGroupType === unitGroupType
          }).objGroupType
          this.resetAccessoryCategoryId()
        }
        this.dispFileDataListCond.unitGroupType = unitGroupType
        this.dispFileDataListCond.umCode = ''
      }
    },
    /** オブジェクトグループ選択 */
    changeObjGrpType: function (event) {
      this.dispFileDataListCond.objGroupType = event.target.dataset.objGrp
      this.dispFileDataListCond.umCode = ''
      this.changeObjGrpTypeCategActive(event)
      this.resetAccessoryCategoryId()
    },
    /** アクセサリー大カテゴリー選択 */
    changeAccessoryCategory: function (accessoryCategoryId) {
      this.dispFileDataListCond.objGroupType = OBJECT_GROUP_TYPE.ACCESSORY.code
      this.dispFileDataListCond.accessoryCategoryId = accessoryCategoryId
      this.dispFileDataListCond.accessorySubCategoryId = this.sortedAccessoryCategory[0].accessoryCategoryId
      this.dispFileDataListCond.umCode = ''
    },
    /** アクセサリー小カテゴリー選択 */
    changeAccessorySubCategory: function (accessorySubCategoryId) {
      this.dispFileDataListCond.objGroupType = OBJECT_GROUP_TYPE.ACCESSORY.code
      this.dispFileDataListCond.accessorySubCategoryId = accessorySubCategoryId
      this.dispFileDataListCond.umCode = ''
    },
    /** カテゴリ選択 */
    changeCategory: function (event) {
      this.dispFileDataListCond.category = parseInt(event.target.dataset.category)
      this.dispFileDataListCond.umCode = ''
      this.changeObjGrpTypeCategActive(event)
      this.resetAccessoryCategoryId()
    },
    //
    /** サービスタイプの変更 */
    changeServiceType: function (serviceType) {
      this.dispFileDataListCond.serviceType = serviceType
      this.dispFileDataListCond.umCode = ''
      this.resetAccessoryCategoryId()
    },
    /** 特注タイプの変更 */
    changeCustomType: function (customType) {
      this.dispFileDataListCond.customType = customType
      this.dispFileDataListCond.umCode = ''
      this.resetAccessoryCategoryId()
    },
    /** 特注タイプの設定 */
    checkCustomType: function (customType) {
      if (this.distCustomTab && this.isGroupTypeSkl) {
        return customType
      } else {
        return ''
      }
    },
    /** オブジェクトグループ・カテゴリーのアクティブタブの切り替え */
    changeObjGrpTypeCategActive: function (event) {
      let element = event.target
      Array.prototype.slice.call(element.parentNode.children).forEach(tab => tab.classList.remove('active'))
      element.classList.add('active')
    },
    /** アクセサリーカテゴリーの初期化 */
    resetAccessoryCategoryId: function () {
      if (this.dispFileDataListCond.unitGroupType === UNIT_GROUP_TYPE.ACCESSORY.code) {
        this.dispFileDataListCond.unitGroupType = ''
      } else {
        this.dispFileDataListCond.accessoryCategoryId = null
        this.dispFileDataListCond.accessorySubCategoryId = null
      }
    },
    /** 問い合わせモーダルの表示 */
    showContact: function () {
      // キャンバスのイベントリスナを無効化
      this.$emit('onShowModal')
      document.addEventListener('keydown', this.onKeydown)
      this.$refs.supportModalRef.showModal(1)
    },
    /** 問い合わせモーダルの非表示 */
    closeContact: function () {
      // キャンバスのイベントリスナを有効化
      this.$emit('onCloseModal')
      document.removeEventListener('keydown', this.onKeydown)
    },
    getContentsResource: function (image) {
      return AppUtil.getContentsResource(image)
    },
    getDarosResource: function (image) {
      return AppUtil.getDarosResource(image)
    },
    noImage: function (element) {
      element.target.src = AppUtil.getDarosResource('noimage.svg')
    },
    menuDisp: function (index) {
      let max = 1
      switch (index) {
        case 0:
          max = 4
          break
        case 1:
          max = 2
          break
        case 2:
          max = 4
          break
        case 3:
          max = 1
          break
        case 4:
          max = 4
          break
        default:
          max = 1
      }
      if (index === 3) {
        max = this.setCategoryTab.length
        if (this.isUnit) {
          let dispList = this.objGroupList.filter((obj) => obj.unitGroupType === this.dispFileDataListCond.unitGroupType)
          max = dispList.length
        }
        if (this.isAccessoryCategory) {
          max = this.accessoryCategoryList.length
        }
      }
      if (index === 4) {
        if (this.isAccessoryCategory) {
          max = this.sortedAccessoryCategory.length
        }
      }

      let itemSize = 89
      let dispSize = this.sideWidth
      var disp = false
      if (max * itemSize > dispSize) {
        disp = true
      }
      return disp
    }
  },
  mounted: function () {
    this.init()
  }
}
</script>
<style src="../../css/planning/side_tab_nav2.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.data_not_found {
  margin-top: 10px;
  color: #565656;
}
#sub_tab_area select {
  margin-bottom: 20px;
}
.side_tab_item {
  position: relative;
}
.main_btn {
  position: absolute;
  bottom: 0;
  margin: 3px;
  box-shadow: none;
  line-height: 25px;
}
.input {
  margin-left: 10px;
  padding: 4px 12px 3px 12px;
}
.side_plan_name {
  width: 188px !important;
  word-wrap: break-word;
}
.side_plan_cd {
  width: 132px !important;
  word-wrap: break-word;
  text-align: right
}
.side_unitlist_left {
  display: flex;
  justify-content: center;
  img {
    display: block;
    margin: auto;
  }
}
.unit_name {
  display: flex;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/SelectUnit2.vue